import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaCaregiver } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { FileList } from "../../../components/fileList.component";
import certificateIcon from "../../../assets/img/Certificate.svg";

type Props = {
  data: ApiSchemaCaregiver | undefined;
  isValidating: boolean;
};

export const CertificateListCard = (props: Props) => {
  const { caregiverId } = useParams<{ caregiverId: string }>();
  const certificateFiles = props.data?.certificates.length
    ? props.data?.certificates.map((certificate) => {
        return certificate.certificateFile;
      })
    : [];
  return (
    <EditableCard
      title="Certificates"
      showLoader
      isValidating={props.isValidating}
      link={`${AppRouteUi.Caregiver.Root()}/update/${caregiverId}`}
    >
      <>
        {props.data?.certificates.length ? (
          <FileList
            files={certificateFiles}
            icon={certificateIcon}
            underScoreCount={3}
          />
        ) : (
          "No Data Available"
        )}
      </>
    </EditableCard>
  );
};
